import React from 'react';
import { DashboardTimezoneModal } from '../../../pages/Dashboard/PerformanceDashboard/DashboardTimezoneModal';
import { CustomDialog } from '../../core/Dialogs/CustomDialog';
import { useTranslation } from '../../../contexts/translation';
export interface Timezone {
  value: string;
  label: string;
}

interface Props {
  title?: string;
  timezone: Timezone;
  isOpen: boolean;
  onChange: (timezone: Timezone) => void;
  onClose: () => void;
}

export function TimezoneChanger({ title, timezone, isOpen, onChange, onClose }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <CustomDialog
        open={isOpen}
        title={title ? title : t('general.timezone.modal-headline')}
        maxWidth={'lg'}
        onClose={onClose}
        overFlowVisible={true}
      >
        <DashboardTimezoneModal defaultTimezone={timezone} onChange={onChange} />
      </CustomDialog>
    </>
  );
}
